<!--
 * @Author: hcw
 * @Date: 2022-08-24 15
-->
<!--
 * @Author: your name
 * @Date: 2022-05-16 17
-->
<template>
    <div>
        <div class="viewDetails" @click="linktohref">
            <div class="viewDetailsText">查看详情</div>
            <div class="viewDetailsShu"></div>
        </div>
    </div>
</template>
<script>
import bus from "@/utils/bus";
import { number } from 'echarts';
export default {
    data(){
        return{}
    },
    props:{
        title:{
            type:String,
            default:"",
        },
        titleTow:{
            type:String,
            default:'',
        },
        topath:{
            type:String,
            default:'',
        },
        actNum:{
            type:Number,
            default:1,
        }
    },
    methods:{
        linktohref(){
            bus.$emit('actNum', this.actNum)
            this.$router.replace({
                path:this.topath
            })
            
        }
    },
    beforeDestroy() {
      bus.$off('actNum');
    },
}
</script>
<style lang="scss" scoped>
.title{
    font-size: 50px;
    color: #ffffff;

}
.titleTow{
    font-size: 18px;
    color: #Facc0a;
    margin-top: 23px;
}
.viewDetails{
    width: 110px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    // background: #EFEFEF;
    // border-left: 3px solid #FFF101;
    margin-top: 17px;
    cursor: pointer;
    font-size: 14px;
    background: rgba(0,0,0,.3);
    color: #ffffff;
    position: relative;
}
.viewDetailsText{
    z-index: 999;
    position: absolute;
    left: 28px;
}
.viewDetailsShu{
    width: 3px;
    height: 34px;
    background: #Facc0a;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
}
.viewDetails:hover{
    .viewDetailsShu{
        width: 110px;
        transition: width 1s;

    }

    color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/indextitle.vue